import React from 'react';

import { useStipReport } from '../../hooks/use-stip-report';
import { useFetchPolos } from '../../hooks/fetch/use-fetch-polos';
import { useFetchVehicleTypes } from '../../hooks/fetch/use-fetch-vehicle-types';
import { useFetchLocations } from '../../hooks/fetch/use-fetch-locations';
import { useFetchFilteredPermissionariesByLine } from '../../hooks/fetch/use-fetch-filtered-permissionaries-by-line';

import Loading from '../../../../layouts/Loading';
import { GridItem } from '../../components/GridItem';
import { ReportTextField } from '../../components/ReportTextField';
import { ReportMultiSelect } from '../../components/ReportMultiSelect';
import { ReportSectionTitle } from '../../components/ReportSectionTitle';
import { ReportMultiAutocomplete } from '../../components/ReportMultiAutocomplete';

const SOMENTE_SLIC = {lineRequest: { boSlic: true, boOrdenarPorNuLinha: true }, boStrip: false};

const SlicLinesReport = () => {
  const { handleSelectChange } = useStipReport();

  const { loading: loadingPolos, polos } = useFetchPolos();
  const { loading: loadingVehicles, vehicleTypes } = useFetchVehicleTypes();
  const { loading: loadingCities, locations: cities } = useFetchLocations();
  const { loading: loadingPermi, lines, permissionaries } = useFetchFilteredPermissionariesByLine(SOMENTE_SLIC);

  const loading = loadingPolos || loadingCities || loadingVehicles || loadingPermi;
  const noPermissionaries = permissionaries.length === 0;

  const permissionariesFieldLabel = noPermissionaries
    ? 'Não há permissionários disponíveis'
    : 'Todos os permissionários';

  if (loading) {
    return <Loading />;
  }

  return (
    <GridItem container spacing={3}>
      <GridItem sm={6}>
        <ReportSectionTitle gutterBottom>Selecione o(s) polos(s):</ReportSectionTitle>
        <ReportMultiAutocomplete
          options={polos}
          onSelect={handleSelectChange}
          label="Todos os polos"
          name="polos"
          valueProperty="cdMunicipio"
          labelProperty="nmMunicipio"
        />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider>Edital:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={3}>
        <ReportTextField name="nuEdital" label="Número do edital" />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider>Opções de filtro:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={6}>
        <ReportSectionTitle gutterBottom>Selecione a(s) localidades(s):</ReportSectionTitle>
        <ReportMultiAutocomplete
          options={cities}
          onSelect={handleSelectChange}
          label="Todas as localidades"
          name="localidades"
          valueProperty="deNome"
          labelProperty="deNome"
        />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider />
      </GridItem>
      <GridItem sm={6}>
        <ReportSectionTitle gutterBottom>Selecione a(s) linha(s):</ReportSectionTitle>
        <ReportMultiAutocomplete
          options={lines}
          onSelect={handleSelectChange}
          label={lines.length === 0 ? 'Não há linhas disponíveis' : 'Todos as linhas'}
          name="linhas"
          valueProperty="cdLinha"
          labelProperty="deDescricao"
          limitTags={1}
        />
      </GridItem>
      <GridItem sm={6}>
        <ReportSectionTitle gutterBottom>Selecione o(s) permissionário(s):</ReportSectionTitle>
        <ReportMultiAutocomplete
          options={permissionaries}
          disabled={noPermissionaries}
          onSelect={handleSelectChange}
          label={permissionariesFieldLabel}
          name="permissionarios"
          valueProperty="cdLinhaPermissionario"
          labelProperty="deNomePermissionario"
          limitTags={1}
          uppercaseLabels
        />
      </GridItem>

      <GridItem>
        <ReportSectionTitle divider>Tipos de veículos:</ReportSectionTitle>
      </GridItem>
      <GridItem sm={6}>
        <ReportMultiSelect
          options={vehicleTypes}
          onSelect={handleSelectChange}
          label="Selecione tipos de veículos"
          name="tiposVeiculo"
          valueProperty="cdTipoVeiculo"
          labelProperty="deTipoVeiculo"
        />
      </GridItem>
    </GridItem>
  );
};

export default SlicLinesReport;
